import { IconProp } from "@fortawesome/fontawesome-svg-core";
import {
  faCalendar,
  faFileInvoiceDollar,
  faFolder,
  faLandmark,
  faUserGroup,
  faUserTie,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Card, Col, Row, Typography } from "antd";

interface Props {
  color: string;
  icon: IconProp;
  url: string;
  text: string;
}

const BLutton: React.FC<Props> = ({ color, icon, url, text }) => {
  const { Text } = Typography;
  return (
    <Col lg={4} md={8} xs={8}>
      <Button
        onClick={() => {
          window.open(url, "_blank", "noopener,noreferrer");
        }}
        style={{ backgroundColor: color, color: "white", width: "100%", height: "100px" }}
      >
        <FontAwesomeIcon icon={icon} size="2x" />
        <br />
        <Text strong style={{ color: "white" }}>
          {text}
        </Text>
      </Button>
    </Col>
  );
};

const Blinstabart = () => {
  return (
    <Card title="BLinstabart">
      <Row gutter={[10, 10]}>
        <BLutton
          text="HA/MP"
          color="#659be0"
          icon={faCalendar}
          url="https://docs.google.com/spreadsheets/d/104BA3G8-HgwUIUxHzCkCSb4o_6BF6ep0wscYx55uJgU/edit?usp=drive_link"
        />
        <BLutton
          text="HA"
          color="#36c7d3"
          icon={faUserTie}
          url="https://docs.google.com/document/d/1KHNKoV7mbRS9k2Rdkm5UTdeG8nWtqk8o/edit"
        />
        <BLutton
          text="MP"
          color="#ed6b75"
          icon={faUserGroup}
          url="https://docs.google.com/document/d/1FteEshrS_2s15dCpUN1ODL5ZxwszopaO/edit#heading=h.gjdgxs"
        />
        <BLutton
          text="Budsjett"
          color="#8e44ad"
          icon={faLandmark}
          url="https://docs.google.com/spreadsheets/d/14oW9p6ON2GWvKhMVurv_IEvQoKlgaTzG1Gb-NGkwTzM/edit#gid=1202707503"
        />
        <BLutton
          text="Faktura"
          color="#1cbc9b"
          icon={faFileInvoiceDollar}
          url="https://docs.google.com/spreadsheets/d/1YYvvcdw8obRf6E8JV4P_yelAGgzAiwDyUwK53cMhv1s/edit?usp=drive_link"
        />
        <BLutton
          text="Katalogen"
          color="#67809f"
          icon={faFolder}
          url="https://drive.google.com/drive/folders/0AK9qoyzG1TwiUk9PVA"
        />
      </Row>
    </Card>
  );
};
export default Blinstabart;
